import React from 'react'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import SubmitButton from '../Form/SubmitButton'

export default function BulkActions({
  onPublish,
  onMarkReadyToPublish,
  onUnmarkReadyToPublish,
  onEdit,
  onDelete,
  onSetMarker,
  disabled,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  /**
   * Wraps actions to close modal after press
   * @param {function} action That will be called on button click
   * @returns
   */
  const actionWrapper = action => () => {
    action()
    handleClose()
  }

  return (
    <div>
      <SubmitButton
        onClick={handleClick}
        value={'Actions'}
        disabled={disabled}
      />
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableEnforceFocus
      >
        {onPublish && (
          <MenuItem onClick={actionWrapper(onPublish)}>Publish</MenuItem>
        )}
        {onMarkReadyToPublish && (
          <MenuItem onClick={actionWrapper(onMarkReadyToPublish)}>
            Mark ready to publish
          </MenuItem>
        )}
        {onUnmarkReadyToPublish && (
          <MenuItem onClick={actionWrapper(onUnmarkReadyToPublish)}>
            Unmark ready to publish
          </MenuItem>
        )}
        {onEdit && <MenuItem onClick={actionWrapper(onEdit)}>Edit</MenuItem>}
        {onDelete && (
          <MenuItem onClick={actionWrapper(onDelete)}>Delete</MenuItem>
        )}
        {onSetMarker && (
          <MenuItem onClick={actionWrapper(onSetMarker)}>
            Add or edit meeting point information
          </MenuItem>
        )}
      </Menu>
    </div>
  )
}
